import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cbs-icon',
  templateUrl: './cbs-icon.component.html',
  styleUrls: ['./cbs-icon.component.scss']
})
export class CbsIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/cbs-icon/cbs-icon.component.ts